/**
 * 선지 채움 진행 표시 — 채워질 빈 선지 자리를 덮는 스켈레톤 바. 진행 문구·취소는 없다(핸드오프 #9).
 * 부모는 `relative` 여야 한다. 바 스펙: 높이 26 · 폭 100% · 단색 gray-200 · radius 4.
 * 바탕은 그라디언트 없이 **단색 풀 강도**로 두고, 그 위를 흰 하이라이트가 좌→우로 훑는다(shimmer).
 * 움직이는 것은 하이라이트뿐이다. 바 전체의 투명도를 오르내리는 pulse 는 바탕을 흐리게 해서 쓰지 않는다.
 */
import { motion, useReducedMotion } from 'framer-motion';
const SHIMMER_DURATION_S = 1.6;
export const OptionFillSkeleton = () => {
  const shouldReduceMotion = useReducedMotion();
  return <div aria-hidden className="pointer-events-none absolute inset-0 z-10 flex items-center bg-default" data-sentry-component="OptionFillSkeleton" data-sentry-source-file="OptionFillSkeleton.tsx">
      <div className="relative h-[26px] w-full overflow-hidden rounded-2xs bg-gray-200">
        {!shouldReduceMotion && <motion.div data-option-fill-shimmer className="absolute inset-y-0 left-0 w-1/2 bg-[linear-gradient(90deg,transparent,rgba(255,255,255,0.85),transparent)]"
      // x 는 자기 폭 기준 — 바 폭이 하이라이트의 2배라 -100% → 200% 가 바 밖에서 밖으로 한 번 훑는 거리다.
      initial={{
        x: '-100%'
      }} animate={{
        x: '200%'
      }} transition={{
        duration: SHIMMER_DURATION_S,
        ease: 'linear',
        repeat: Infinity
      }} />}
      </div>
    </div>;
};